import React from 'react';
import { baseColors } from '@groupby/ui-components';
import styled, { css } from 'styled-components';
import SvgIcon from '@mui/material/SvgIcon';
const StyledContainer = styled.div `
  .search-icon {
    width: 100%;
    height: 15%;
  }
  .map-icon {
    width: 100%;
    padding-top: 1rem;
    height: ${({ $withSearch }) => ($withSearch ? '75%' : '100%')};
  }
  .highlight {
    fill: url(#moving-gradient);
  }

  ${({ $withAnimation }) => !$withAnimation && css `
    linearGradient {
      transform: none;
    }
    .map-icon {
      path {
        fill: ${baseColors.background000};
      }
    }
  `}
`;
export const KeyTermGeographyLoadingIcon = ({ withSearch, withAnimation, className }) => (<StyledContainer className={className} $withAnimation={withAnimation} $withSearch={withSearch}>
    {withSearch && (<SvgIcon className='search-icon' preserveAspectRatio="none" viewBox="0 0 390 52" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="0.0791016" width="100%" height="52" fill="#F8F8FA"/>
      </SvgIcon>)}
    <SvgIcon className='map-icon' width="100%" height="100%" viewBox="0 0 306 253" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="moving-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#F7F7FB"/>
          <stop offset="35%" stopColor="#DEE4EE"/>
          <stop offset="65%" stopColor="#DEE4EE"/>
          <stop offset="100%" stopColor="#F7F7FB"/>
          <animateTransform attributeName="gradientTransform" type="translate" from="-1" to="1" dur="2.5s" repeatCount="indefinite" calcMode="spline" keySplines="0.42 0 0.58 1"/>
        </linearGradient>
      </defs>
      <path className="highlight" d="M172.593 7.97548L66.9237 0L3.08201 78.8687L0 132.482H61.2L64.282 142.673H139.131L142.213 162.611H217.062V182.993L232.032 197.172L213.54 253L306 186.095L256.688 182.993L236.435 167.042L217.062 81.5271L200.771 73.9947V51.8406L168.63 32.345L172.593 7.97548Z"/>
    </SvgIcon>
  </StyledContainer>);
